import { useSelector, useDispatch } from "react-redux";
import SubmitButtonGroup from "../../../../UiElement/FormElement/SubmitBtnGroup";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import { useEffect } from "react";
import useHttpHook from "../../../../../Hooks/HttpHook";
import { EventById } from "../../../../../utils/ApiConstant";
import { updEventData } from "../../../../../ReduxSlice/Event/eventSlice";
import { toast } from "react-toastify";
import { showErrorToast } from "../../../../../utils/notify";

const EmailList = (props) => {
  const { eventId } = useParams();
  const dispatch = useDispatch();
  const [loading, sendRequest, error] = useHttpHook();
  const eventData = useSelector((state) => state.event);
  const navigate = useNavigate();

  const getEventData = async () => {
    const event = await sendRequest(EventById + eventId);
    dispatch(updEventData(event));
  };

  useEffect(() => {
    getEventData();
  }, []);

  useEffect(() => {
    if (error) {
      if (toast.isActive(error) === false) {
        showErrorToast(error);
        if (error === "You are unAuthrised") {
          window.location.href = `${process.env.REACT_APP_MERCH_URL}/login`;
        }
      }
    }
  }, [error]);

  const emails =
    eventData.status &&
    eventData.data.settings.emailSms.filter(
      (emailSms) => emailSms?.notificationType === props.ListType
    );

  return (
    <div className="event-settings-email-panel">
      <div className="event-settings-email-table-wrap">
        <table className="event-settings-email-table" aria-label="Sent attendee emails">
          <colgroup>
            <col className="event-settings-email-col-serial" />
            <col className="event-settings-email-col-subject" />
            <col className="event-settings-email-col-attendees" />
            <col className="event-settings-email-col-date" />
            <col className="event-settings-email-col-time" />
            <col className="event-settings-email-col-link" />
            <col className="event-settings-email-col-status" />
          </colgroup>
          <thead>
            <tr>
              <th scope="col" className="is-center">
                Sr. No.
              </th>
              <th scope="col">Sub</th>
              <th scope="col" className="is-center">
                Total Attendee
              </th>
              <th scope="col">Date</th>
              <th scope="col">Time</th>
              <th scope="col" className="is-center">
                Quick Link
              </th>
              <th scope="col" className="is-center">
                Status
              </th>
            </tr>
          </thead>
          <tbody>
            {emails && emails.length > 0 ? (
              emails.map((email, index) => (
                <tr key={email._id || index}>
                  <td className="is-center">{index + 1}</td>
                  <td>
                    <span className="event-settings-email-subject">
                      {email.subject}
                    </span>
                  </td>
                  <td className="is-center">
                    {eventData.data.attendeeCount ??
                      eventData.data.attendees?.length ??
                      0}
                  </td>
                  <td>
                    {moment(email.sendNotification?.dateTime).format(
                      "MMM Do YY"
                    )}
                  </td>
                  <td>
                    {moment(email.sendNotification?.dateTime).format(
                      "h:mm:ss a"
                    )}
                  </td>
                  <td className="is-center">
                    <button
                      type="button"
                      className="event-settings-email-link"
                      onClick={() => props.ClickHandler(email)}
                      aria-label="Edit email"
                    >
                      <i className="bi bi-pencil-square" aria-hidden="true"></i>
                    </button>
                    <button
                      type="button"
                      className="event-settings-email-link is-danger"
                      onClick={() => props.DeleteHandler(email)}
                      aria-label="Delete email"
                    >
                      <i className="bi bi-trash3" aria-hidden="true"></i>
                    </button>
                  </td>
                  <td className="is-center">
                    <span
                      className={`event-settings-email-status${
                        email.isSent === true ? " is-sent" : " is-scheduled"
                      }`}
                    >
                      {email.isSent === true ? "Sent" : "Scheduled"}
                    </span>
                  </td>
                </tr>
              ))
            ) : (
              <tr className="event-settings-email-empty-row">
                <td colSpan={7}>
                  <div className="event-settings-email-empty">
                    <i className="bi bi-envelope" aria-hidden="true"></i>
                    <p>No emails scheduled yet.</p>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <SubmitButtonGroup
        clickHandler={() => {
          props.Stepper();
          navigate(`/myEvents/${eventId}/addons`);
        }}
        GroupClassName="event-settings-footer"
        HideCancelBtn={true}
        isLoading={loading}
      />
    </div>
  );
};

export default EmailList;
